import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import { withOktaAuth } from '@okta/okta-react';

import { getImageUrl } from './messages/actions';
import { getOktaSettings } from '../actions';

const MaintenanceScreen = (props) => {
  const [imgPath] = useState(props.oktaSettings.maintenanceMode);

  const onSignOut = () => props.oktaAuth.signOut();

  const externalCloseBtn = (
    <Button
      color="primary"
      onClick={onSignOut}
      className="close-Button"
      style={{ position: 'absolute', top: '15px', right: '15px' }}>
      Sign Out
    </Button>
  );

  return (
    <div className="underMaintenancePreview">
      <Modal className="reasonAreaPreview" isOpen={true} size="lg" fullscreen>
        <ModalHeader>{externalCloseBtn}</ModalHeader>
        <img
          className="reasonImagePreview"
          src={imgPath}
          alt="Under maintenance"
          style={{
            maxWidth: '800px',
          }}
        />
      </Modal>
    </div>
  );
};

MaintenanceScreen.propTypes = {
  getImageUrl: PropTypes.func,
  getOktaSettings: PropTypes.func,
  oktaAuth: PropTypes.object,
  oktaSettings: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    oktaSettings: state.okta.settings,
  };
};

export default connect(mapStateToProps, { getImageUrl, getOktaSettings })(
  withOktaAuth(MaintenanceScreen)
);
